<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phụ lục Hợp đồng ký thêm</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="gets">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.keySearch"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.groupService"
              :options="dataGroupServiceSelect"
              @change="queryService($event)"
              placeholder="Nhóm dịch vụ"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="sales-manager"
              v-model="search.serviceTypes"
              :options="dataConfigService"
              :settings="{ placeholder: 'Dịch vụ' }"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="sales-manager"
              v-model="search.regionIds"
              :options="dataConfigRegion"
              @change="queryProvince($event)"
              :settings="{ placeholder: 'Vùng kinh doanh' }"
            />
          </div>
          <div class="form-group">
            <select2-multiple-control
              v-model="search.cityCodes"
              :options="dataProvince"
              :settings="{ placeholder: 'Tỉnh/Thành phố' }"
            />
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.code"
              type="text"
              class="f12"
              placeholder="Số hợp đồng"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.formContract"
              :options="formContract"
              placeholder="Hình thức"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.paymentType"
              :options="paymentTypeData"
              placeholder="Hình thức mua TB"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.isDefaultFee" :options="isDefaulValue" placeholder="Phí" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.customerType"
              :options="customerType"
              placeholder="Loại hợp đồng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeAppendix"
              :options="Config.getSearch(Config.typeAppendix)"
              placeholder="Loại phụ lục"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.superiorId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.saleId" :options="listUser" placeholder="Nhân viên" />
          </div>
          <div class="form-group">
            <Select2MultipleControl
              :settings="{ placeholder: 'Trạng thái', closeOnSelect: false }"
              v-model="search.state"
              :options="listStatusContract"
            >
            </Select2MultipleControl>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.agentId"
              :options="listCollaborators"
              placeholder="Cộng tác viên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.stateCollaborator"
              :options="listStateCollaborator"
              placeholder="Trạng thái GS"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusReceipt"
              :options="listStatusReceipt"
              placeholder="Trạng thái phiếu thu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.statusHandover"
              :options="Config.getSearch(Config.statusHandoverList)"
              placeholder="Trạng thái bàn giao"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.referSource" :options="sourceCreate" placeholder="Nguồn tạo" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.agentGroup" :options="dataAgentGroup" placeholder="Nhóm CTV" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.approverId"
              :options="listUser"
              placeholder="Người duyệt/từ chối"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.appraisalStatus"
              :options="Config.appraisalStatus"
              placeholder="Trạng thái VH thẩm định"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.multiFuncAppendixType"
              :options="systemConfig.multiFuncAppendixType"
              placeholder="Loại phụ lục bổ sung"
            />
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="gets()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            <div>
              Tổng hợp đồng:
              <strong class="text-primary">{{
                objectCount.totalAppendix ? objectCount.totalAppendix : 0
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Chưa ký:
              <strong class="text-primary">{{
                objectCount.totalNotSign ? objectCount.totalNotSign : 0
              }}</strong>
              &nbsp;&nbsp;| &nbsp;&nbsp; Đã ký:
              <strong class="text-primary">{{
                objectCount.totalSigned ? objectCount.totalSigned : 0
              }}</strong>
            </div>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="listContract"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(groupService)="data">
                {{ data.item.groupService | fomatTextService(dataGroupService) }}
              </template>
              <template #cell(service)="data">
                {{ data.item.service | serviceTypes }}
              </template>
              <template #cell(merchant)="data">
                <p>
                  <span>{{
                    data.item.merchantData ? data.item.merchantData.merchantName : ''
                  }}</span>
                </p>
                <p
                  v-if="
                    !(
                      data.item.merchantData &&
                      data.item.merchantData.accIdType &&
                      data.item.merchantData.accIdType === 'MOBILE'
                    )
                  "
                >
                  <a href="#">{{ data.item.merchantData ? data.item.merchantData.email : '' }}</a>
                </p>
                <p>
                  <a href="#">{{
                    data.item.merchantData ? data.item.merchantData.mobile : '' | encryptPhone
                  }}</a>
                </p>
                <p>
                  <span
                    >{{ data.item.merchantData ? data.item.merchantData.address : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.district : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.city : '' }}</span
                  >
                </p>
                <p>
                  <Status :value="data.item.mcLvl" :config="Config.mcKeyLvl" />
                </p>
              </template>
              <template #cell(contractTime)="data">
                <p>
                  HĐ:
                  <span>{{
                    data.item.merchantData && data.item.merchantData.customerType | fomatCustomtype
                  }}</span>
                </p>
                <p>
                  Số: <b>{{ data.item.code }}</b>
                </p>
                <p v-if="data.item.dateCreate">
                  Ngày tạo: <span>{{ data.item.dateCreate | formatDate }}</span>
                </p>
                <p v-if="data.item.dateSign">
                  Ngày ký: <span>{{ data.item.dateSign | formatDate }}</span>
                </p>
                <p v-if="data.item.dateCancel">
                  Ngày huỷ: <span>{{ data.item.dateCancel | formatDate }}</span>
                </p>
              </template>
              <template #cell(typeAppendix)="data">
                {{ data.item.typeAppendix | transformData(Config.typeAppendix) }}
              </template>
              <template #cell(appendixTime)="data">
                <p v-if="data.item.appendixDateCreate">
                  Ngày tạo: <span>{{ data.item.appendixDateCreate | formatDate }}</span>
                </p>
                <p v-if="data.item.appendixDateSign">
                  Ngày ký: <span>{{ data.item.appendixDateSign | formatDate }}</span>
                </p>
                <p v-if="data.item.appendixDateCancel">
                  Ngày huỷ: <span>{{ data.item.appendixDateCancel | formatDate }}</span>
                </p>
                <p v-if="data.item.approvedOrRejectedDate">
                  Ngày duyệt/từ chối:
                  <span>{{ data.item.approvedOrRejectedDate | formatDate }}</span>
                </p>
              </template>
              <template #cell(devices)="data">
                <div v-if="data.item.numDevices && data.item.numDevices !== 0">
                  <p>
                    SL: <span>{{ data.item.numDevices }}</span>
                  </p>
                  <p>
                    TT:
                    <span>{{
                      data.item.priceDevices ? data.item.priceDevices : 0 | fomatCurrency
                    }}</span>
                  </p>
                </div>
                <p v-if="data.item?.deposit">
                  Tiền cọc:
                  <span>{{ data.item?.deposit ? data.item?.deposit : 0 | fomatCurrency }}</span>
                </p>
              </template>
              <template #cell(packageData)="data">
                <p
                  v-if="
                    data.item.packageData &&
                    data.item.packageData.timePackage &&
                    data.item.packageData.timePackage !== '' &&
                    data.item.packageData.timePackage !== '0'
                  "
                >
                  TG:
                  <span>{{
                    data.item.packageData.timePackage ? data.item.packageData.timePackage : ''
                  }}</span>
                  <br />
                  TT:
                  <span>{{
                    data.item.packageData.price ? data.item.packageData.price : 0 | fomatCurrency
                  }}</span>
                </p>
              </template>
              <template #cell(sale)="data">
                <p>
                  <b>{{ data.item.saleInfo ? data.item.saleInfo.name : '' }}</b>
                </p>
                <p>
                  <a href="#">{{ data.item.saleInfo ? data.item.saleInfo.userName : '' }}</a>
                </p>
                <p>{{ data.item.saleInfo ? data.item.saleInfo.regionName : '' }}</p>
              </template>
              <template #cell(referSource)="data">
                {{ data.item.merchantData ? data.item.merchantData.referSource : '' }}
              </template>
              <template #cell(approvedOrRejectedExecutor)="data">
                {{ getNameApprovedOrRejectedExecutor(data.item.approvedOrRejectedExecutor) }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | mapTextStatus(listStatusContract) }}</span
                >
                <br />
                {{ data.item.stateCollaborator | mapTextStatus(listStateCollaborator) }}
              </template>
              <template #cell(statusReceipt)="data">
                <span
                  class="badge"
                  :class="[status ? status : '']"
                  v-for="(status, indexx) in data.item.statusReceipt"
                  :key="indexx"
                >
                  {{ status | mapTextStatus(listStatusReceipt) }}
                </span>
              </template>
              <template #cell(mposDetermined)="data">
                <p v-if="data.item.appraisalStatus">
                  Tình trạng thẩm định MPOS:
                  {{ data.item.appraisalStatus | transformData(Config.statusDeterminedMpos) }}
                </p>
                <p v-if="data.item.appraiser">
                  Người thẩm định/yêu cầu bổ sung: {{ data.item.appraiser }}
                </p>
                <p v-if="data.item.appraisalTime">
                  Thời gian thẩm định/yêu cầu bổ sung:
                  {{ data.item.appraisalTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(statusHandover)="data">
                <span
                  class="badge"
                  :class="[data.item.statusHandover ? data.item.statusHandover : '']"
                >
                  {{ data.item.statusHandover | mapTextStatus(Config.statusHandoverList) }}
                </span>
              </template>
              <template #cell(reason)="data">
                <span
                  v-if="data.item.status === 'REJECTED_SA' || data.item.status === 'REJECTED_MA'"
                >
                  <p
                    class="form-control-plaintext f12"
                    v-if="
                      data.item.reasonRejected &&
                      data.item.reasonRejected[data.item.reasonRejected.length - 1]
                    "
                  >
                    {{
                      data.item.reasonRejected
                        ? data.item.reasonRejected[data.item.reasonRejected.length - 1]
                        : ''
                    }}
                  </p>
                  <p class="form-control-plaintext f12" v-else>
                    {{
                      data.item.reasonRejectedBYMPOS
                        ? data.item.reasonRejectedBYMPOS[data.item.reasonRejectedBYMPOS.length - 1]
                        : ''
                    }}
                  </p>
                </span>
                <span v-if="data.item.status === 'ADDITIONAL'">
                  <p v-if="data.item.reasonAddImage && data.item.reasonAddImage[0]">
                    {{ data.item.reasonAddImage[0] }}
                  </p>
                  <p v-else-if="data.item.reasonAddInfo && data.item.reasonAddInfo[0]">
                    {{ data.item.reasonAddInfo[0] }}
                  </p>
                  <p v-else-if="data.item.reasonRejected && data.item.reasonRejected[0]">
                    {{ data.item.reasonRejected[0] }}
                  </p>
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  class="text-center"
                  variant="outline-light"
                  v-if="dataPermission && dataPermission.includes('CNPS_SCON_INFO_BY_CODE')"
                >
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="openModalDetail(data.item)"
                  >
                    <i class="bx bx-show-alt"></i> Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="totalRows"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { SalesManagerService } from '@/services/sales-manager.service'
  import Config from '../../thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { ContractService } from '../../services/contract.service'
  import { AgentService } from '@/services/agent.service'
  import cloneDeep from 'lodash/cloneDeep'
  import mxAppendix from './mxAppendix'
  import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'groupService', label: 'Nhóm dịch vụ', thStyle: 'min-width: 80px' },
    { key: 'service', label: 'Dịch vụ' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'contractTime', label: 'Hợp đồng/Ngày ký', thStyle: 'min-width: 280px' },
    { key: 'typeAppendix', label: 'Loại phụ lục', thStyle: 'min-width: 130px' },
    { key: 'appendixTime', label: 'Phụ lục/Ngày ký', thStyle: 'min-width: 280px' },
    { key: 'devices', label: 'Thiết bị', thStyle: 'min-width: 120px' },
    { key: 'packageData', label: 'Giá gói', thStyle: 'min-width: 120px' },
    { key: 'sale', label: 'Sale' },
    { key: 'approvedOrRejectedExecutor', label: 'Người duyệt/từ chối' },
    { key: 'referSource', label: 'Nguồn MC' },
    { key: 'status', label: 'Trạng thái phụ lục' },
    { key: 'statusReceipt', label: 'Trạng thái phiếu thu', thStyle: 'min-width: 80px' },
    { key: 'mposDetermined', label: 'MPOS thẩm định', thStyle: 'min-width: 80px' },
    { key: 'statusHandover', label: 'Trạng thái XNBG', thStyle: 'min-width: 80px' },
    { key: 'reason', label: 'Lý do', fixIndex: 999, class: 'text-center' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          limit: 15,
          page: 1,
        },
        dataConfigRegion: [],
        dataProvince: [],
        dataGroupService: [],
        dataGroupServiceSelect: [],
        dataConfigService: [],
        formContract: Config.formContract,
        paymentTypeData: Config.paymentType,
        isDefaulValue: Config.isDefaulValue,
        customerType: Config.customerType,
        listUser: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listStatusContract: Config.listStatusContract,
        listContract: [],
        objectCount: {},
        totalRows: 0,
        loading: false,
        showLoading: false,
        contractStateSign: [
          'SIGNED_MISS_IMAGE',
          'SIGNED_WAITING_APPROVED',
          'APPROVED',
          'LIQUIDATE',
          'REJECTED_SA',
          'ADDITIONAL',
        ],
        contractStateOther: [
          'NEW',
          'WAITING_APPROVED_FEE',
          'APPROVED_FEE',
          'SENT',
          'WAITING_SIGN',
          'SIGNING',
          'REJECTED_MC',
          'REJECTED_MA',
        ],
        listCTVSource: [
          { id: '0', text: 'Tất cả' },
          { id: 'DIRECT_SALES', text: 'DirectSales' },
          { id: 'AGENCY', text: 'Cộng tác viên' },
          { id: 'MARKETING', text: 'Marketing' },
        ],
        listCollaborators: [],
        listStateCollaborator: [
          { id: 0, text: 'Tất cả' },
          { id: 'APPROVED', text: 'GS đã duyệt' },
          { id: 'WAITING', text: 'Chờ GS duyệt' },
          { id: 'REJECTED', text: 'GS từ chối' },
        ],
        listStatusReceipt: [
          { id: 0, text: 'Tất cả' },
          { id: 'NEW', text: 'Mới tạo' },
          { id: 'PENDING_APPROVAL', text: 'Chờ duyệt' },
          { id: 'DONE', text: 'Đã thu tiền' },
          { id: 'CANCEL', text: 'Bị huỷ' },
          { id: 'WAIT_SETTLEMENT', text: 'Chờ kết toán' },
        ],
        dataAgentGroup: Config.dataAgentGroup,
        sourceCreate: Config.sourceCreate,
        hasDefaultFilter: true,
      }
    },
    mixins: [mxAppendix],
    watch: {
      'search.page': function () {
        this.gets()
      },
      'search.limit': function () {
        this.gets()
      },
    },

    created() {
      const { from, to } = getLastNDays(3, 'date')
      this.dateRange = {
        startDate: from,
        endDate: to,
      }
      this.getRegions()
      this.groupService()
      this.getListStaffBySuperior()
      this.getListCTV()
      this.gets()
      this.getConfigSystem()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          if (data.data.length > 0) {
            const dataUser = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
              dataUser.push(body)
            })
            this.listUser = dataUser
            return
          }
          this.listUser = []
        } catch (error) {
          console.log(error)
        }
      },

      openModalDetail(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },

      clearSearch() {
        this.search = {
          page: 1,
          limit: 15,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dataProvince = []
        this.hasDefaultFilter = false
        this.gets()
      },

      removeDefaultFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.gets()
      },

      async getRegions() {
        const dataRes = await StaffService.getRegions()
        if (dataRes.data.length > 0) {
          const dataRegion = [
            {
              id: 0,
              text: 'Tất cả',
            },
          ]
          dataRes.data.map(e => {
            dataRegion.push({ id: e.id, text: e.name })
          })
          this.dataConfigRegion = dataRegion
        }
      },

      async groupService() {
        try {
          const respon = await SalesManagerService.getGroupService({})
          if (respon.code === 1000) {
            this.dataGroupService = respon.data.groupService
            const dataGroupService = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            this.dataGroupService.map(e => {
              const body = {
                id: e.service,
                text: e.name,
              }
              dataGroupService.push(body)
            })
            this.dataGroupServiceSelect = dataGroupService
            return
          }
          this.dataGroupService = []
        } catch (error) {
          console.log(error, '=========>')
        }
      },

      async queryProvince(e) {
        try {
          this.search.cityCodes = null
          const data = await StaffService.getProvinceRegion({ regionId: e })
          if (data.data.length > 0) {
            const dataProvince = [
              {
                id: 0,
                text: 'Tất cả',
              },
            ]
            data.data.map(e => {
              const body = {
                id: e.code,
                text: e.name,
              }
              dataProvince.push(body)
            })
            this.dataProvince = dataProvince
            return
          }
          this.dataProvince = []
        } catch (error) {}
      },

      async queryService(service) {
        try {
          if (!service) return
          this.dataConfigService = []
          const data = this.dataGroupService.find(e => e.service === service)
          if (data.detail.length > 0) {
            data.detail.map(e => {
              const body = {
                id: e.code,
                text: this.serviceTypes(e.name),
              }
              this.dataConfigService.push(body)
            })
          }
        } catch (error) {
          console.log(error)
        }
      },

      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },

      async formatData() {
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }

        if (this.search.serviceTypes && this.search.serviceTypes.length === 0)
          delete this.search.serviceTypes
        if (this.search.regionIds && this.search.regionIds.length === 0)
          delete this.search.regionIds
        if (this.search.cityCodes && this.search.cityCodes.length === 0)
          delete this.search.cityCodes

        if (this.search.cityCodes && this.search.cityCodes !== null) {
          this.search.cityCodes.map((e, key) => {
            if (e === '0') {
              this.search.cityCodes.splice(key, 1)
              if (this.search.cityCodes.length === 0) {
                delete this.search.cityCodes
              }
            }
          })
        }

        if (this.search.regionIds && this.search.regionIds !== null) {
          this.search.regionIds.map((e, key) => {
            if (e === '0') {
              this.search.regionIds.splice(key, 1)
              if (this.search.regionIds.length === 0) {
                delete this.search.regionIds
              }
            }
          })
        }

        if (this.search.code && this.search.code.includes(' ')) {
          const index = this.search.code.indexOf(' ')
          const length = this.search.code.length
          const code = this.search.code.slice(0, index) + this.search.code.slice(index + 1, length)
          this.search.code = code
        }
      },

      // xuất Excel
      async exportExcel() {
        try {
          if (isNaN(this.search.dateTo)) {
            this.showFailMx('Phải lọc thời gian')
          } else {
            if (this.search.dateTo - this.search.dateFrom > 5356799999) {
              this.showFailMx('Vui lòng lọc dưới 2 tháng')
            } else {
              await this.formatData()
              const search = cloneDeep(this.search)
              search.page = 1
              search.limit = 1
              this.showLoading = true
              await ContractService.exportListAppendixContract(search)
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },

      async gets() {
        try {
          this.loading = true
          this.formatData()
          const data = await ContractService.getListAppendixContract(this.search)
          if (data.code === 1000) {
            this.objectCount = {
              totalAppendix: data.totalPage.total,
              totalNotSign: data.data.totalNotSign,
              totalSigned: data.data.totalSigned,
            }
            this.totalRows = data.totalPage.total
            this.listContract = data.data.appendixList
            return
          }
          this.listContract = []
        } catch (error) {
          console.log(error, '=========>')
        } finally {
          this.loading = false
        }
      },

      async getListCTV() {
        try {
          const dataItem = await AgentService.listAgentByUser({
            userId: this.dataUser.userId,
          })
          if (dataItem.success) {
            this.listCollaborators = [{ id: 0, text: 'Tất cả' }]
            dataItem.data.map(e => {
              this.listCollaborators.push({ id: e.agentId, text: e.name })
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      getNameApprovedOrRejectedExecutor(data) {
        return data?.name ?? ''
      },
    },

    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
  }
</script>

<style>
  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }

    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }

    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }

  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }

  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    color: #fff;
    background-color: #ffc107;
  }

  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }

  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
